/**
 * Brand interaction affordance: pointer cursor, 400 ms easing, subtle hover scale.
 * Technical tokens: `app/globals.css` (`--interaction-*`).
 */
export const interactiveClasses =
    'cursor-pointer transition-all duration-[var(--interaction-duration)] ease-[var(--interaction-easing)] hover:scale-[var(--interaction-scale)] active:scale-100 motion-reduce:transition-none motion-reduce:hover:scale-100'

/**
 * Dense controls (select triggers, comboboxes): same motion language without hover scale —
 * scaling full-width fields causes overflow and horizontal scroll in modals/dialogs.
 */
export const interactiveSurfaceClasses =
    'cursor-pointer transition-[box-shadow,border-color,background-color,opacity] duration-[var(--interaction-duration)] ease-[var(--interaction-easing)] motion-reduce:transition-none'
